import queries from '@apis/queries';
import { useQuery } from '@tanstack/react-query';

function useInquiry(inquiryId: string) {
  const { data: inquiry, status } = useQuery(queries.inquiry.detail(inquiryId));
  const isLoading = status === 'pending';
  return { inquiry, isLoading };
}

export default useInquiry;
